export const API_BASE = process.env.REACT_APP_BACKEND || "http://localhost:5000";
export const NOTES_PER_PAGE = 9;
